module.exports = __webpack_public_path__ + "media/Hermit_Thrush.78e81491.mp3";